import React, { useState } from 'react'
import { Row, Col } from 'antd'

import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {dateFormatter} from "../../services/helper";


import 'pages/Salary/index.scss'
import './index.scss'

import { ScreenTitle } from 'components/ScreenTitle'
import { DepositList } from 'pages/Deposits/components/DepositList'
import { useTranslation } from 'react-i18next';


const Deposits: React.FC<any> = (props) => {
  const {t} = useTranslation()
const history = useHistory()

  const onClickRight = () => {
    window.location.reload()
  }
  const onClickLeft = () => {
    history.push('/')
  }
  return (
    <>
      <Row>
        <Col span={24}>
          <ScreenTitle
            onClickRight={onClickRight}
            onClickLeft={onClickLeft}
            leftValue={t("home.deposits")}
            rightValue={dateFormatter(new Date())}
          />
          <div className="tableBox">
            <DepositList />
          </div>
        </Col>
      </Row>
    </>
  )
}
const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
})
export default connect(mapStateToProps, null)(Deposits)
